import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import { Box, HStack, VStack, Text, Flex, Image, Link as CLink, Center, Divider } from '@chakra-ui/react';
import { FaSignOutAlt } from 'react-icons/fa';

const LogoutLink = ({ email, onClick }) => {
  return (
    <CLink
      _focus={{ boxShadow: 'none ' }}
      width={'100%'}
      textAlign={'left'}
      py={2}
      px={2}
      m={0}
      fontWeight={700}
      _hover={{ bg: '#11284B', color: '#fff', textDecoration: 'none' }}
      onClick={onClick}
    >
      <HStack spacing={2}>
        <HStack>
          <FaSignOutAlt />
          <Text>Logout</Text>
        </HStack>
        <Text color={'#929292'}>{email}</Text>
      </HStack>
    </CLink>
  );
};

LogoutLink.propTypes = {
  email: PropTypes.string,
  onClick: PropTypes.func,
};

export default LogoutLink;



// WEBPACK FOOTER //
// src/components/login/LogoutLink/LogoutLink.jsx